import { SearchParams } from '@/types'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export interface ICreateWaterSourcePayload {
  name: string
  interfaceId: number
  flowValveId: number
  flowSensorId: number
  description: string
  cost: number
}

export interface IDeleteWaterSourcePayload {
  id: number | string
}

export interface IUpdateWaterSourcePayload
  extends ICreateWaterSourcePayload,
    IDeleteWaterSourcePayload {}

export interface IWaterSource
  extends ICreateWaterSourcePayload,
    IDeleteWaterSourcePayload {
  interfaceId: number
  flowValveType: number
  flowValveTypeDesription: string
  flowSensorName: string
  flowValveName: string
}

const waterSourceApi = {
  getAll(searchParams: SearchParams) {
    const url = '/api/watersource'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(payload: IDeleteWaterSourcePayload): Promise<{ data: IWaterSource }> {
    const { id } = payload
    const url = `api/watersource/${id}`
    return axiosClient.get(url)
  },

  create(payload: ICreateWaterSourcePayload) {
    const url = 'api/watersource'
    return axiosClient.post(url, payload)
  },

  update(payload: IUpdateWaterSourcePayload) {
    const { id, ...args } = payload
    const url = `api/watersource/${id}`
    return axiosClient.put(url, args)
  },

  delete(
    payload: IDeleteWaterSourcePayload & { interfaceId: number | string },
  ) {
    const { id } = payload
    const url = `api/watersource/${id}`
    return axiosClient.delete(url)
  },

  getListFlowValve(searchParams: SearchParams) {
    const url = '/api/watersource/flowvalve'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getListFlowSensor(searchParams: SearchParams) {
    const url = '/api/watersource/flowsensor'
    return axiosClient.get(url + queryStringify(searchParams))
  },
}

export default waterSourceApi
